import { PermanentJobsApi } from '../clients';
import { IUpdateCandidateStatusPayload } from '../types';

export const updateCandidateStatus = async (
  payload: IUpdateCandidateStatusPayload,
): Promise<void> => PermanentJobsApi.updateCandidateStatus(payload);
